"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLanguage = void 0;
var formatLanguage = function (data, language) {
    var input = __assign({}, data);
    var languageRegex = /(\w+)_([a-z]{2})(.*)/;
    var inputKeys = Object.keys(input).filter(function (key) { return languageRegex.test(key); });
    inputKeys.forEach(function (key) {
        var property = key.match(languageRegex);
        if (!property) {
            return;
        }
        var propertyKey = property[1];
        var propertyLanguage = property[2];
        var rest = property[3];
        if (language === propertyLanguage) {
            input["".concat(propertyKey, "Translation").concat(rest)] = input[key];
        }
        delete input[key];
    });
    return input;
};
exports.formatLanguage = formatLanguage;
